import { useState, useEffect } from "react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const AdminSubscribers = () => {
  const [subs, setSubs] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    axios.get(`${API}/api/admin/subscribers`).then(r => setSubs(r.data)).catch(() => {});
  }, []);

  const filtered = subs.filter(s => !search || s.email.toLowerCase().includes(search.toLowerCase()));

  const deleteSub = async (id) => {
    if (!window.confirm("Remove this subscriber?")) return;
    try {
      await axios.delete(`${API}/api/admin/subscribers/${id}`);
      setSubs(prev => prev.filter(s => s.id !== id));
      toast.success("Subscriber removed");
    } catch { toast.error("Failed to remove"); }
  };

  const exportCSV = () => {
    const header = "Email,Subscribed Date,Status\n";
    const rows = subs.map(s => `"${s.email}","${new Date(s.subscribed_at).toLocaleDateString()}","${s.status}"`).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `paradigm-subscribers-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
    URL.revokeObjectURL(url);
    toast.success("Subscribers exported!");
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem", flexWrap: "wrap", gap: ".75rem" }}>
        <div>
          <h3 style={{ fontSize: "1rem", fontWeight: 700, color: "#1F2937", margin: "0 0 .2rem" }}>Mailing List</h3>
          <p style={{ fontSize: ".82rem", color: "#9CA3AF", margin: 0 }}>{subs.length} total subscribers</p>
        </div>
        <div style={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
          <div style={{ position: "relative" }}>
            <i className="fas fa-search" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9CA3AF", fontSize: ".75rem" }} />
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search email..." style={{ padding: ".4rem .7rem .4rem 2rem", border: "1px solid #D1D5DB", borderRadius: 6, fontSize: ".82rem", width: 220 }} />
          </div>
          <button onClick={exportCSV} style={{ display: "flex", alignItems: "center", gap: ".4rem", padding: ".5rem 1rem", borderRadius: 8, border: "1px solid #D1D5DB", background: "#fff", color: "#374151", cursor: "pointer", fontSize: ".82rem", fontWeight: 500 }}>
            <i className="fas fa-download" /> Export CSV
          </button>
        </div>
      </div>

      <div style={{ background: "#fff", borderRadius: 12, boxShadow: "0 1px 3px rgba(0,0,0,.06)", overflow: "hidden" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "3rem", color: "#9CA3AF" }}>
            <i className="fas fa-envelope-open-text" style={{ fontSize: "2rem", marginBottom: ".5rem", display: "block" }} />
            <p style={{ fontWeight: 500 }}>{search ? "No subscribers match" : "No subscribers yet"}</p>
            <p style={{ fontSize: ".82rem" }}>Subscribers will appear here when visitors sign up via the newsletter form</p>
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #E5E7EB", background: "#F9FAFB" }}>
                <th style={{ textAlign: "left", padding: ".7rem 1rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase", letterSpacing: ".05em" }}>Email</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Subscribed</th>
                <th style={{ textAlign: "left", padding: ".7rem .5rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280", textTransform: "uppercase" }}>Status</th>
                <th style={{ textAlign: "right", padding: ".7rem 1rem", fontSize: ".75rem", fontWeight: 600, color: "#6B7280" }}></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.id} style={{ borderBottom: "1px solid #F3F4F6" }}>
                  <td style={{ padding: ".7rem 1rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: ".6rem" }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg, #EC4899, #F97316)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: ".65rem", fontWeight: 700, flexShrink: 0 }}>
                        <i className="fas fa-envelope" />
                      </div>
                      <span style={{ fontWeight: 500, color: "#1F2937", fontSize: ".85rem" }}>{s.email}</span>
                    </div>
                  </td>
                  <td style={{ padding: ".7rem .5rem", color: "#9CA3AF", fontSize: ".82rem" }}>{new Date(s.subscribed_at).toLocaleDateString()}</td>
                  <td style={{ padding: ".7rem .5rem" }}>
                    <span style={{ padding: ".15rem .5rem", borderRadius: 50, fontSize: ".7rem", fontWeight: 600, background: "rgba(16,185,129,.1)", color: "#059669" }}>Active</span>
                  </td>
                  <td style={{ padding: ".7rem 1rem", textAlign: "right" }}>
                    <button onClick={() => deleteSub(s.id)} title="Remove" style={{ width: 30, height: 30, borderRadius: 6, border: "1px solid #FEE2E2", background: "#FEF2F2", cursor: "pointer", color: "#EF4444", fontSize: ".75rem" }}>
                      <i className="fas fa-trash" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
